import { useEffect, useMemo, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { publicMenu, publicProfile, getCategories } from "../api/menupro.api";
import "./publicmenu.css";

export default function PublicMenu() {
    const { slug } = useParams();

    const [products, setProducts] = useState([]);
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);

    // ✅ search + categories
    const [q, setQ] = useState("");
    const [activeCat, setActiveCat] = useState("ALL");
    const [cats, setCats] = useState([]);
    // ✅ UI states
    const [addedId, setAddedId] = useState(null);      // hansı məhsula "✓ əlavə edildi" göstərilsin
    const addedTimerRef = useRef(null);

    const [productModal, setProductModal] = useState(null); // click olunan məhsul

    const catWrapRef = useRef(null);
    const catBtnRefs = useRef({});

    // ✅ CART
    const cartKey = useMemo(() => `mp_cart_${slug}`, [slug]);
    const [cartOpen, setCartOpen] = useState(false);
    const [cart, setCart] = useState(() => {
        try {
            const raw = localStorage.getItem(cartKey);
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    });

    // ✅ Biznes phone -> wa.me
    // ✅ Business phone -> WhatsApp (wa.me)
    const normalizeAzPhone = (raw) => {
        if (!raw) return "";
        let p = String(raw).replace(/[^\d]/g, ""); // yalnız rəqəm

        // 0XXXXXXXXX (10 rəqəm) -> 994XXXXXXXXX
        if (p.startsWith("0") && p.length === 10) p = "994" + p.slice(1);

        // artıq 994 ilə başlayırsa saxla
        if (p.startsWith("994")) return p;

        return p; // fallback
    };

    const bizPhoneDigits = useMemo(() => {
        return normalizeAzPhone(profile?.phone);
    }, [profile?.phone]);

    // ✅ Business phone -> WhatsApp base (NO text here)
    const waBizBase = useMemo(() => {
        if (!bizPhoneDigits) return null;
        return `https://wa.me/${bizPhoneDigits}`;
    }, [bizPhoneDigits]);

    // ✅ WhatsApp icon/button (default short message)
    const waBizLink = useMemo(() => {
        if (!waBizBase) return null;
        const text = encodeURIComponent("Salam. Menyunuzu gördüm, sifariş vermək istəyirəm.");
        return `${waBizBase}?text=${text}`;
    }, [waBizBase]);

    // localStorage sync
    useEffect(() => {
        try {
            localStorage.setItem(cartKey, JSON.stringify(cart));
        } catch { }
    }, [cartKey, cart]);

    const cartCount = useMemo(
        () => cart.reduce((s, x) => s + (Number(x.qty) || 0), 0),
        [cart]
    );

    const cartTotal = useMemo(
        () => cart.reduce((s, x) => s + (Number(x.qty) || 0) * (Number(x.price) || 0), 0),
        [cart]
    );

    const pickBusinessId = (prof, items) => {
        // prof biznesdirsə (publicProfile slug -> mp_business qaytarır)
        if (prof?.id != null) return prof.id;

        // prof içində ayrıca businessId varsa
        if (prof?.businessId != null) return prof.businessId;

        // menu item üstündən
        const first = items?.[0];
        return (
            first?.businessId ??
            first?.business?.id ??
            null
        );
    };

    const addToCart = (p) => {
        setCart((prev) => {
            const id = String(p.id);
            const idx = prev.findIndex((x) => String(x.id) === id);
            const priceNum = Number(p.price) || 0;

            if (idx >= 0) {
                const copy = [...prev];
                copy[idx] = { ...copy[idx], qty: (copy[idx].qty || 0) + 1 };
                return copy;
            }

            return [
                {
                    id: p.id,
                    title: p.title,
                    price: priceNum,
                    image: p.image || "",
                    qty: 1,
                },
                ...prev,
            ];
        });
    };

    const incQty = (id) => {
        setCart((prev) =>
            prev.map((x) => (String(x.id) === String(id) ? { ...x, qty: (x.qty || 0) + 1 } : x))
        );
    };

    const decQty = (id) => {
        setCart((prev) =>
            prev
                .map((x) =>
                    String(x.id) === String(id) ? { ...x, qty: Math.max(1, (x.qty || 1) - 1) } : x
                )
        );
    };

    const removeItem = (id) => {
        setCart((prev) => prev.filter((x) => String(x.id) !== String(id)));
    };

    const clearCart = () => setCart([]);

    useEffect(() => {
        return () => {
            if (addedTimerRef.current) clearTimeout(addedTimerRef.current);
        };
    }, []);

    const orderText = useMemo(() => {
        if (!cart.length) return "";

        const lines = [];
        lines.push("Salam sifariş vermək isdəyirdim.\n");

        cart
            .slice()
            .reverse()
            .forEach((x) => {
                lines.push(`• ${x.title} ×${x.qty} — ${(Number(x.price) || 0) * x.qty} ₼`);
            });

        lines.push(`\nCəmi: ${cartTotal.toFixed(2)} ₼`);
        lines.push(`\nMenyu: https://mototaksi.az/${slug}`);

        return lines.join("\n");
    }, [cart, cartTotal, slug]);

    // ✅ Order link (cart message)
    const waOrderLink = useMemo(() => {
        if (!waBizBase || !orderText) return null;
        return `${waBizBase}?text=${encodeURIComponent(orderText)}`;
    }, [waBizBase, orderText]);

    useEffect(() => {
        if (!slug) return;
        loadAll();
        // eslint-disable-next-line
    }, [slug]);

    const loadAll = async () => {
        try {
            setLoading(true);

            const [pRes, mRes] = await Promise.all([
                publicProfile(slug),
                publicMenu(slug),
            ]);

            const prof = pRes.data;
            const items = mRes.data || [];

            setProfile(prof);
            setProducts(items);

            // ✅ businessId-ni HARD tap
            const businessId =
                prof?.id ??
                prof?.businessId ??
                items?.[0]?.businessId ??
                items?.[0]?.business?.id ??
                null;

            console.log("PUBLIC PROFILE:", prof);
            console.log("PUBLIC MENU FIRST ITEM:", items?.[0]);
            console.log("BUSINESS ID:", businessId);

            if (businessId) {
                // ✅ ƏSAS: category adlarını çək
                const cRes = await getCategories(businessId); // -> /category/{businessId}
                setCats(cRes.data || []);
            } else {
                // ✅ fallback: uniq categoryId-lərdən "Kateqoriya X" yarat
                const uniq = new Map();
                items.forEach((p) => {
                    const id = p.categoryId;
                    if (id == null) return;
                    const key = String(id);
                    if (!uniq.has(key)) uniq.set(key, { id, name: `Kateqoriya ${id}` });
                });
                setCats(Array.from(uniq.values()));
            }

            setActiveCat("ALL");
            setQ("");
        } catch (e) {
            console.log(e);
            setProfile(null);
            setProducts([]);
            setCats([]);
        } finally {
            setLoading(false);
        }
    };

    const scrollCatToCenter = (key) => {
        const wrap = catWrapRef.current;
        const btn = catBtnRefs.current[key];
        if (!wrap || !btn) return;

        const wrapRect = wrap.getBoundingClientRect();
        const btnRect = btn.getBoundingClientRect();
        const currentScroll = wrap.scrollLeft;

        const btnCenter = btnRect.left + btnRect.width / 2;
        const wrapCenter = wrapRect.left + wrapRect.width / 2;

        const delta = btnCenter - wrapCenter;
        wrap.scrollTo({ left: currentScroll + delta, behavior: "smooth" });
    };

    const onSelectCat = (key) => {
        setActiveCat(key);
        scrollCatToCenter(key);
    };

    const activeCatTitle =
        activeCat === "ALL"
            ? "Hamısı"
            : (cats.find((x) => String(x.id) === String(activeCat))?.name || "Kateqoriya");

    // ✅ filter
    const filtered = useMemo(() => {
        const text = q.trim().toLowerCase();
        return (products || [])
            .filter((p) => {
                if (activeCat === "ALL") return true;
                return String(p.categoryId) === String(activeCat);
            })

            .filter((p) => {
                if (!text) return true;
                const t = (p.title || "").toLowerCase();
                const d = (p.description || "").toLowerCase();
                return t.includes(text) || d.includes(text);
            });
    }, [products, q, activeCat]);

    return (
        <div className="pm-wrap">
            {/* ✅ Banner: only one text */}
            <div className="pm-topBanner">
                <Link className="pm-bannerLink" to="/menupro/register">
                    Biznes hesabı yaradın
                </Link>
            </div>

            <main className="pm-main">
                {loading ? (
                    <div className="pm-loading">Yüklənir...</div>
                ) : !profile ? (
                    <div className="pm-empty">Restoran tapılmadı.</div>
                ) : (
                    <>
                        {/* ✅ Profile hero (premium gradient + new shape) */}
                        <section className="pm-hero">
                            <div className="pm-heroGlass">
                                <div className="pm-heroTop">
                                    <img
                                        className="pm-avatar"
                                        src={profile.profileImage || "https://img.icons8.com/fluent/1200/shop.jpg"}
                                        alt=""
                                    />

                                    <div className="pm-heroText">
                                        <h1 className="pm-biz">{profile.businessName}</h1>
                                        <p className="pm-bio">{profile.bio || "Bio əlavə edilməyib"}</p>

                                        {waBizLink ? (
                                            <a
                                                className="pm-waIconBtn"
                                                href={waBizLink}
                                                target="_blank"
                                                rel="noreferrer"
                                                aria-label="WhatsApp"
                                                title="WhatsApp"
                                            >
                                                <svg viewBox="0 0 32 32" fill="none">
                                                    <path
                                                        d="M16 3C9.4 3 4 8.1 4 14.4c0 2.5.9 4.9 2.5 6.9L5 29l7.9-1.9c1.9 1 4 1.5 6.2 1.5
        6.6 0 12-5.1 12-11.4S22.6 3 16 3Z"
                                                        fill="currentColor"
                                                        opacity="0.22"
                                                    />
                                                    <path
                                                        d="M16 5.2c-5.4 0-9.8 4.2-9.8 9.2 0 2.2.8 4.2 2.2 5.9l-1 4.7 4.9-1.2
        c1.4.8 3 .9 4.6.9 5.4 0 9.8-4.2 9.8-9.2S21.4 5.2 16 5.2Zm5.7 12.2c-.2.6-1 1.1-1.7 1.2
        -.5.1-1.1.1-1.8-.1-2.9-.8-4.7-3.2-4.9-3.4-.2-.3-1.2-1.5-1.2-2.9 0-1.4.8-2.1 1-2.3
        .2-.2.5-.3.7-.3h.5c.2 0 .4 0 .5.4.2.4.6 1.5.7 1.6.1.1.1.3 0 .5-.1.2-.1.3-.3.5
        -.1.1-.3.3-.4.4-.1.1-.2.2-.1.4.1.2.5 1 1.1 1.6.8.8 1.4 1 1.7 1.1.2.1.4 0 .5-.1
        .1-.1.6-.7.7-1 .2-.2.3-.2.5-.1.2.1 1.5.7 1.7.8.2.1.4.2.4.3.1.1.1.5-.1 1Z"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                            </a>
                                        ) : (
                                            <div className="pm-waMuted">WhatsApp nömrəsi qeyd edilməyib</div>
                                        )}

                                    </div>
                                </div>
                            </div>

                            {/* ✅ shape */}
                            <div className="pm-heroDeco" aria-hidden="true">
                                <div className="pm-heroBlob" />
                                <div className="pm-heroRing" />
                                <div className="pm-heroDiag" />
                            </div>

                        </section>

                        {/* ✅ Search + count (bizdəki kimi) */}
                        <div className="pm-toolbar">
                            <div className="pm-searchWrap">
                                <input
                                    className="pm-search"
                                    placeholder="Məhsul axtar... (məs: burger, kola)"
                                    value={q}
                                    onChange={(e) => setQ(e.target.value)}
                                />
                                {q && (
                                    <button className="pm-clear" onClick={() => setQ("")} title="Təmizlə">
                                        ×
                                    </button>
                                )}
                            </div>

                            <div className="pm-count">{filtered.length} məhsul</div>
                        </div>

                        {/* ✅ Category chips (bizdəki kimi) */}
                        <div className="pm-catWrap" ref={catWrapRef}>
                            <button
                                ref={(el) => (catBtnRefs.current["ALL"] = el)}
                                className={`pm-catChip ${activeCat === "ALL" ? "active" : ""}`}
                                onClick={() => onSelectCat("ALL")}
                            >
                                Hamısı
                            </button>

                            {cats.map((c) => (
                                <button
                                    key={c.id}
                                    ref={(el) => (catBtnRefs.current[String(c.id)] = el)}
                                    className={`pm-catChip ${String(activeCat) === String(c.id) ? "active" : ""
                                        }`}
                                    onClick={() => onSelectCat(String(c.id))}
                                >
                                    {c.name}
                                </button>
                            ))}
                        </div>

                        {/* ✅ category title center */}
                        <div className="pm-productsHead">
                            <div className="pm-productsTitle">{activeCatTitle}</div>
                        </div>

                        {/* ✅ Products */}
                        {filtered.length === 0 ? (
                            <div className="pm-empty">Heç nə tapılmadı.</div>
                        ) : (
                            <div className="pm-products">
                                {filtered.map((p) => (
                                    <div
                                        className="pm-rowcard"
                                        key={p.id}
                                        onClick={() => setProductModal(p)}
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => e.key === "Enter" && setProductModal(p)}
                                    >

                                        <div className="pm-left">
                                            <div className="pm-pTitle">{p.title}</div>

                                            {p.description ? (
                                                <div className="pm-pDesc">{p.description}</div>
                                            ) : (
                                                <div className="pm-pDesc pm-muted">Açıqlama yoxdur</div>
                                            )}

                                            <div className="pm-bottom">
                                                <div className="pm-price">{p.price} ₼</div>

                                                <button
                                                    className={`pm-cartBtn ${String(addedId) === String(p.id) ? "added" : ""}`}
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // ✅ modal açılmasın
                                                        addToCart(p);
                                                        setAddedId(String(p.id));
                                                        if (addedTimerRef.current) clearTimeout(addedTimerRef.current);
                                                        addedTimerRef.current = setTimeout(() => setAddedId(null), 2200);
                                                    }}
                                                >

                                                    <span className="pm-cartSvg" aria-hidden="true">
                                                        {/* ✅ white cart icon */}
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                            <path
                                                                d="M6.5 6h14l-1.4 7.2a2 2 0 0 1-2 1.6H9.2a2 2 0 0 1-2-1.6L5.6 3.8H3"
                                                                stroke="#fff"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                            <path
                                                                d="M9 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM18 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                                                                fill="#fff"
                                                            />
                                                        </svg>
                                                    </span>
                                                    {String(addedId) === String(p.id) ? "✓ Səbətə əlavə edildi" : "Səbətə əlavə et"}
                                                </button>
                                            </div>
                                        </div>

                                        <div className="pm-right">
                                            <img
                                                className="pm-img"
                                                src={p.image || "https://img.icons8.com/fluent/1200/shop.jpg"}
                                                alt=""
                                                loading="lazy"
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </>
                )}
            </main>

            {/* ✅ Floating Cart Button */}
            {profile && !cartOpen && (
                <button
                    className="pm-fab"
                    type="button"
                    onClick={() => setCartOpen(true)}
                    aria-label="Səbət"
                >
                    <span className="pm-fabIcon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M6.5 6h14l-1.4 7.2a2 2 0 0 1-2 1.6H9.2a2 2 0 0 1-2-1.6L5.6 3.8H3"
                                stroke="#fff"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M9 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM18 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                                fill="#fff"
                            />
                        </svg>
                    </span>

                    {cartCount > 0 && <span className="pm-fabBadge">{cartCount}</span>}
                </button>
            )}

            {/* ✅ Product Modal */}
            {productModal && (
                <div className="pm-mOverlay" onMouseDown={() => setProductModal(null)}>
                    <div className="pm-mCard" onMouseDown={(e) => e.stopPropagation()}>
                        <button className="pm-mClose" onClick={() => setProductModal(null)} aria-label="Bağla">
                            ×
                        </button>

                        <div className="pm-mImgWrap">
                            <img
                                className="pm-mImg"
                                src={productModal.image || "https://img.icons8.com/fluent/1200/shop.jpg"}
                                alt=""
                            />
                        </div>

                        <div className="pm-mBody">
                            <div className="pm-mTop">
                                <div className="pm-mTitle">{productModal.title}</div>
                                <div className="pm-mPrice">{productModal.price} ₼</div>
                            </div>

                            <div className="pm-mDesc">
                                {productModal.description || "Açıqlama yoxdur"}
                            </div>

                            <button
                                className={`pm-mAdd ${String(addedId) === String(productModal.id) ? "added" : ""}`}
                                type="button"
                                onClick={() => {
                                    addToCart(productModal);

                                    setAddedId(String(productModal.id));
                                    if (addedTimerRef.current) clearTimeout(addedTimerRef.current);
                                    addedTimerRef.current = setTimeout(() => setAddedId(null), 2200);

                                    setProductModal(null); // ✅ modal bağla
                                }}

                            >
                                {String(addedId) === String(productModal.id) ? "✓ Səbətə əlavə edildi" : "Səbətə əlavə et"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ✅ Drawer */}
            {cartOpen && (
                <div className="pm-dOverlay" onMouseDown={() => setCartOpen(false)}>
                    <div className="pm-drawer" onMouseDown={(e) => e.stopPropagation()}>
                        <div className="pm-dHead">
                            <div className="pm-dTitle">Səbət</div>
                            <button className="pm-dClose" onClick={() => setCartOpen(false)}>×</button>
                        </div>

                        {cart.length === 0 ? (
                            <div className="pm-dEmpty">Səbət boşdur.</div>
                        ) : (
                            <>
                                <div className="pm-dList">
                                    {cart.map((x) => (
                                        <div className="pm-dItem" key={x.id}>
                                            <img
                                                className="pm-dImg"
                                                src={x.image || "https://img.icons8.com/fluent/1200/shop.jpg"}
                                                alt=""
                                            />

                                            <div className="pm-dMeta">
                                                <div className="pm-dName">{x.title}</div>
                                                <div className="pm-dPrice">{Number(x.price).toFixed(2)} ₼</div>

                                                <div className="pm-dActions">
                                                    <div className="pm-stepper">
                                                        <button onClick={() => decQty(x.id)}>-</button>
                                                        <span>{x.qty}</span>
                                                        <button onClick={() => incQty(x.id)}>+</button>
                                                    </div>

                                                    <button className="pm-dRemove" onClick={() => removeItem(x.id)}>
                                                        Sil
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="pm-dLineTotal">
                                                {(Number(x.price) * x.qty).toFixed(2)} ₼
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="pm-dFoot">
                                    <div className="pm-dTotalRow">
                                        <span>Cəmi</span>
                                        <b>{cartTotal.toFixed(2)} ₼</b>
                                    </div>

                                    <div className="pm-dBtns">
                                        <button className="pm-dClear" onClick={clearCart}>Təmizlə</button>

                                        <a
                                            className={`pm-dOrder ${!waOrderLink ? "disabled" : ""}`}
                                            href={waOrderLink || "#"}
                                            onClick={(e) => {
                                                if (!waOrderLink) {
                                                    e.preventDefault();
                                                    return;
                                                }
                                                // ✅ WhatsApp açılacaq, biz də səbəti təmizləyək
                                                clearCart();
                                                // istəsən drawer-i də bağlaya bilərsən:
                                                // setCartOpen(false);
                                            }}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            WhatsApp ilə sifariş
                                        </a>

                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}

            <footer className="pm-footer">
                <span>© {new Date().getFullYear()} • MenyuPro</span>
            </footer>
        </div>
    );
}

